var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Icon',_vm._b({directives:[{name:"tooltip",rawName:"v-tooltip.right",value:(_vm.text),expression:"text",modifiers:{"right":true}}],staticClass:"help",style:(_vm.checkedStyle),attrs:{"name":"question-circle","size":_vm.size}},'Icon',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }